<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <SearchByProduct
          v-on:ordersResult="ordersResult"
          v-on:clear="clear"
        ></SearchByProduct>
      </div>
    </div>

    <Table path="pecas" :orders="orders"></Table>
  </div>
</template>

<script>
import Table from "../Table.vue";
import SearchByProduct from "./SearchByProduct.vue";
export default {
  components: {
    Table,
    SearchByProduct,
  },
  data() {
    return {
      orders: [],
    };
  },
  computed: {},
  methods: {
    ordersResult(ordersResult) {
      this.orders = ordersResult;
    },
    clear() {
      this.orders = [];
    },
  },
  async created() {},
};
</script>



